// Helpers for drawing sprites with pivot, scale, rotation, alpha.

export interface SpriteDrawOptions {
  x: number;
  y: number;
  width: number;
  height: number;
  pivotX?: number; // 0..1, default 0.5
  pivotY?: number; // 0..1, default 0.5
  rotation?: number; // radians
  alpha?: number; // 0..1
  scale?: number; // uniform scale multiplier
  tintColor?: string; // overlays color multiplied by tintAmount
  tintAmount?: number; // 0..1
  circular?: boolean; // clip image to a circle
}

export function drawSprite(
  ctx: CanvasRenderingContext2D,
  image: CanvasImageSource,
  opts: SpriteDrawOptions,
): void {
  const {
    x,
    y,
    width,
    height,
    pivotX = 0.5,
    pivotY = 0.5,
    rotation = 0,
    alpha = 1,
    scale = 1,
    tintColor,
    tintAmount = 0,
    circular = false,
  } = opts;

  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(x, y);
  if (rotation !== 0) ctx.rotate(rotation);
  if (scale !== 1) ctx.scale(scale, scale);
  if (circular) {
    ctx.beginPath();
    ctx.arc(0, 0, Math.min(width, height) * 0.5, 0, Math.PI * 2);
    ctx.clip();
  }
  ctx.drawImage(image, -width * pivotX, -height * pivotY, width, height);

  if (tintColor && tintAmount > 0) {
    ctx.globalCompositeOperation = "source-atop";
    ctx.globalAlpha = alpha * tintAmount;
    ctx.fillStyle = tintColor;
    ctx.fillRect(-width * pivotX, -height * pivotY, width, height);
  }

  ctx.restore();
}
